import React, { Component } from "react";
import "../../../../assets/css/detailInfo.css";
import { setClassNameCondition } from "../../../../lib/helper";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { withTranslation } from "react-i18next";
class DetailInfomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthTab: "all",
      chartOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "areaspline",
          backgroundColor: "#181A20",
        },
        title: {
          text: null,
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          type: "datetime",
          accessibility: {
            rangeDescription: this.formatRangeDateDataForChart(),
          },
          labels: {
            format: "{value:%m/%d}",
            style: {
              color: "#fff",
            },
          },
          gridLineWidth: 1,
          gridLineDashStyle: "Dash",
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: { style: { color: "#e22a67" } },
            gridLineWidth: 0,
          },
          {
            title: {
              text: null,
            },
            opposite: true,
            labels: { style: { color: "#30d6ce" } },
            gridLineWidth: 0,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
            pointStart: Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ),
            pointIntervalUnit: "day",
          },
          areaspline: {
            fillOpacity: 0.5,
          },
        },
        series: [
          {
            name: "Tổng số nhà giao dịch mới",
            yAxis: 1,
          },
        ],
      },
      ratioVal: "totalTrade",
    };
    this.chartRef = React.createRef();
  }

  getRankIconForUser = (userRank) => {
    const urls = {
      "Vip 1": "images/rank1.png",
      "Vip 2": "images/rank2.png",
      "Vip 3": "images/rank3.png",
      "Vip 4": "images/rank4.png",
      "Vip 5": "images/rank5.png",
      "Vip 6": "images/rank6.png",
      "Vip 7": "images/rank7.png",
    };
    return urls[userRank] || null;
  };
  handleSelectMonthTab = (tab) => {
    this.setState({ monthTab: tab });
  };
  formatRangeDateDataForChart() {
    let rangeDate = "";
    const currentDate = new Date();

    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );

    // Hàm để lấy hậu tố cho ngày
    function getDaySuffix(day) {
      const suffix = ["th", "st", "nd", "rd"];
      const val = day % 100;
      return suffix[(val - 20) % 10] || suffix[val] || suffix[0];
    }

    // Hàm định dạng ngày theo kiểu "April 1st 2024"
    function formatDateWithSuffix(date) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const day = date.getDate();
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      return `${month} ${day}${getDaySuffix(day)} ${year}`;
    }

    const firstDayFormatted = formatDateWithSuffix(firstDayOfMonth);
    const lastDayFormatted = formatDateWithSuffix(lastDayOfMonth);

    rangeDate = `Range: ${firstDayFormatted} to ${lastDayFormatted}.`;

    return rangeDate;
  }
  handleChangeRadio(e) {
    this.setState({ ratioVal: e.target.value });
  }
  fillMissingDays(data) {
    // Lấy ngày hiện tại và ngày đầu tháng
    const currentDate = new Date();
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    startOfMonth.setHours(startOfMonth.getHours() + 8);
    // Tạo mảng các ngày trong tháng từ ngày đầu tháng đến ngày hiện tại
    const allDates = [];
    let tempDate = new Date(startOfMonth);

    while (tempDate <= currentDate) {
      allDates.push(tempDate.toISOString().split("T")[0]); // Định dạng ngày theo "YYYY-MM-DD"
      tempDate.setDate(tempDate.getDate() + 1); // Tăng ngày lên
    }

    // Mảng kết quả điền dữ liệu
    const filledData = {};

    allDates.forEach((date) => {
      // Kiểm tra nếu ngày có trong dữ liệu
      if (data[date]) {
        filledData[date] = data[date];
      } else {
        // Nếu không có trong dữ liệu, điền giá trị là dữ liệu của ngày trước đó
        const prevDate = allDates[allDates.indexOf(date) - 1];
        if (prevDate) {
          filledData[date] = filledData[prevDate];
        } else {
          // Nếu là ngày đầu tháng và không có dữ liệu, gán giá trị là 0
          filledData[date] = 0;
        }
      }
    });

    return filledData;
  }
  previousMonthDate() {
    const currentDate = new Date();
    const previousMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());

    const year = previousMonthDate.getFullYear().toString(); // Get last two digits of the year
    const month = (previousMonthDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
    const day = previousMonthDate.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  getPointStart(data) {
    const dateData = Object.keys(data).length !== 0 ? Object.keys(data)[0] : this.previousMonthDate();
    const startDate = new Date(dateData);
    const pointStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    return pointStart;
  }
  getPointEnd(data) {
    if (Object.keys(data).length === 0) return null;
    const dateData = Object.keys(data)
    const endDate = dateData[dateData.length - 1];
    const end = new Date(endDate);
    const pointEnd = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    return pointEnd;
  }
  fillMissingDaysAll(data) {
    const allDate = Object.keys(data);
    let startDate = allDate[0];
    let endDate = allDate[allDate.length - 1];
    const startTime = new Date(startDate);
    const endTime = new Date(endDate);
    const allDates = [];
    while (endTime >= startTime) {
      allDates.push(startTime.toISOString().split("T")[0]); // Định dạng ngày theo "YYYY-MM-DD"
      startTime.setDate(startTime.getDate() + 1);
    }
    const filledData = {};

    allDates.forEach((date) => {
      // Kiểm tra nếu ngày có trong dữ liệu
      if (data[date]) {
        filledData[date] = data[date];
      } else {
        // Nếu không có trong dữ liệu, điền giá trị là dữ liệu của ngày trước đó
        const prevDate = allDates[allDates.indexOf(date) - 1];
        if (prevDate) {
          filledData[date] = filledData[prevDate];
        } else {
          // Nếu là ngày đầu tháng và không có dữ liệu, gán giá trị là 0
          filledData[date] = 0;
        }
      }
    });
    return filledData;
  }
  fillMissingDaysLastMonth(data) {
    let lastMonth_firstDate = Object.keys(data)[0];
    // Lấy ngày đầu tiên có dữ liệu và ngày cuối tháng
    const startDate = new Date(lastMonth_firstDate);
    const endOfMonth = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      0
    );
    endOfMonth.setHours(endOfMonth.getHours());
    // Tạo mảng các ngày trong tháng từ ngày đầu có dữ liệu đến ngày cuối tháng
    const allDates = [];
    let tempDate = new Date(endOfMonth);

    while (tempDate >= startDate) {
      allDates.push(startDate.toISOString().split("T")[0]); // Định dạng ngày theo "YYYY-MM-DD"
      startDate.setDate(startDate.getDate() + 1);
    }

    // Mảng kết quả điền dữ liệu
    const filledData = {};

    allDates.forEach((date) => {
      // Kiểm tra nếu ngày có trong dữ liệu
      if (data[date]) {
        filledData[date] = data[date];
      } else {
        // Nếu không có trong dữ liệu, điền giá trị là dữ liệu của ngày trước đó
        const prevDate = allDates[allDates.indexOf(date) - 1];
        if (prevDate) {
          filledData[date] = filledData[prevDate];
        } else {
          // Nếu là ngày đầu tháng và không có dữ liệu, gán giá trị là 0
          filledData[date] = 0;
        }
      }
    });
    return filledData;
  }
  setDataChart = () => {
    const currentDate = new Date().getDate();
    const ArrIfNull = Array(currentDate).fill(0);

    if (this.state.monthTab === "all") {
      if (this.state.ratioVal === "totalTrade") {
        let missingTrade = {};
        if (this.props?.userInfo?.totalTradeAll) {
          missingTrade =
            this.fillMissingDaysAll(this.props?.userInfo?.totalTradeAll) || {};
        }
        const chartTradeData = Object.values(missingTrade).length > 0 ? Object.values(missingTrade) : ArrIfNull;

        this.chartRef?.current?.chart?.series[0]?.setData(chartTradeData);
        this.chartRef?.current?.chart?.series[0]?.update({
          name: "Tổng khối lượng giao dịch",
          color: "#30D6CE",
        });
        if (Object.values(missingTrade).length === 0) return;
        const pointStart = this.getPointStart(missingTrade);
        const pointEnd = this.getPointEnd(missingTrade);
        this.chartRef?.current?.chart?.series[0]?.update({
          pointStart: pointStart,
          pointEnd: pointEnd
        });
      } else if (this.state.ratioVal === "commission") {
        let comissionData = {};
        if (this.props?.userInfo?.totalCommissionAll) {
          comissionData =
            this.fillMissingDaysAll(
              this.props?.userInfo?.totalCommissionAll
            ) || {};
        }
        const chartTradeData = Object.values(comissionData).length > 0 ? Object.values(comissionData) : ArrIfNull;
        this.chartRef?.current?.chart?.series[0]?.setData(chartTradeData);
        this.chartRef?.current?.chart?.series[0]?.update({
          name: "Tổng khối lượng hoa hồng",
          color: "#E22A67",
        });
        if (Object.values(comissionData).length === 0) return;
        const pointStart = this.getPointStart(comissionData);
        const pointEnd = this.getPointEnd(comissionData);
        this.chartRef?.current?.chart?.series[0]?.update({
          pointStart: pointStart,
          pointEnd: pointEnd
        });
      }
    } else if (this.state.monthTab === "current") {
      if (this.state.ratioVal === "totalTrade") {
        let missingTrade = {};
        if (this.props?.userInfo?.totalTradeCurrentMonth) {
          missingTrade =
            this.fillMissingDays(
              this.props?.userInfo?.totalTradeCurrentMonth
            ) || {};
        }
        const chartTradeData = Object.values(missingTrade || 0) || ArrIfNull;
        this.chartRef?.current?.chart?.series[0]?.setData(chartTradeData);
        this.chartRef?.current?.chart?.series[0]?.update({
          name: "Tổng khối lượng giao dịch",
          color: "#30D6CE",
        });
      } else if (this.state.ratioVal === "commission") {
        let comissionData = {};
        if (this.props?.userInfo?.totalCommissionCurrentMonth) {
          comissionData =
            this.fillMissingDays(
              this.props?.userInfo?.totalCommissionCurrentMonth
            ) || {};
        }
        const chartTradeData = Object.values(comissionData || 0) || ArrIfNull;
        this.chartRef?.current?.chart?.series[0]?.setData(chartTradeData);
        this.chartRef?.current?.chart?.series[0]?.update({
          name: "Tổng khối lượng hoa hồng",
          color: "#E22A67",
        });
      }
    } else {
      if (this.state.ratioVal === "totalTrade") {
        let missingTrade = {};
        if (this.props?.userInfo?.totalTradeLastMonth) {
          missingTrade =
            this.fillMissingDaysLastMonth(this.props?.userInfo?.totalTradeLastMonth) ||
            {};
        }
        const chartTradeData = Object.values(missingTrade).length > 0 ? Object.values(missingTrade) : ArrIfNull;
        // Set lại điểm bắt đầu cho biểu đồ

        this.chartRef?.current?.chart?.series[0]?.setData(chartTradeData);
        this.chartRef?.current?.chart?.series[0]?.update({
          pointStart: this.getPointStart(missingTrade),
          name: "Tổng khối lượng giao dịch",
          color: "#30D6CE",
        });
      } else if (this.state.ratioVal === "commission") {
        let comissionData = {};
        if (this.props?.userInfo?.totalCommissionLastMonth) {
          comissionData =
            this.fillMissingDaysLastMonth(
              this.props?.userInfo?.totalCommissionLastMonth
            ) || {};
        }
        const chartComissionData = Object.values(comissionData).length > 0 ? Object.values(comissionData) : ArrIfNull;
        this.chartRef?.current?.chart?.series[0]?.setData(chartComissionData);
        this.chartRef?.current?.chart?.series[0]?.update({
          pointStart: this.getPointStart(comissionData),
          name: "Tổng khối lượng giao dịch hoa hồng",
          color: "rgb(250, 75, 98)",
        });

      }
    }
  };
  componentDidUpdate(prevpops, prevstate) {
    this.setDataChart();
  }
  componentDidMount() {
    this.setDataChart();
  }
  render() {
    const { userInfo } = this.props;
    const { t } = this.props;
    const userRank = this.getRankIconForUser(userInfo.vip);
    const userAvatar = userInfo.image
      ? userInfo.image
      : "/images/icon/avatar_default.svg";
    return (
      <div className="detail-info-wrapper">
        <div className="back-button-wrapper">
          <button
            className="back-button"
            onClick={() => {
              this.props.handleCloseDetailInfomation();
            }}
          >
            <i className="fas fa-arrow-left"></i>
            {t("Back")}
          </button>
          <p>{userInfo?.name || "user name"}</p>
        </div>
        <div
          className="row"
          style={{
            gap: "30px",
            margin: 0,
            marginTop: "16px",
          }}
        >
          <div
            className="col-12 col-lg"
            style={{
              minHeight: "270px",
              padding: "20px",
              border: "1px solid #303539",
              borderRadius: "20px",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                margin: "41px 0 52px 0",
              }}
            >
              {userInfo?.vip === "Không" && (
                <p
                  style={{
                    padding: "10px",
                    border: "1px solid red",
                    borderRadius: "10px",
                    color: "red",
                  }}
                >
                  {t("NoVipAuthorization")}
                </p>
              )}
              {userInfo?.vip !== "Không" && (
                <div
                  className="border border-warning rounded-lg d-flex align-items-center justify-content-center text-warning position-relative"
                  style={{
                    width: "155px",
                    height: "45px",
                    borderRadius: "14px",
                    marginLeft: "40px",
                  }}
                >
                  <div
                    className="m-0 text-warning"
                    style={{
                      fontSize: "13px",
                      paddingLeft: "20px",
                    }}
                  >
                    {t("Rank")}
                  </div>
                  <div
                    className="ml-2 border d-flex align-items-center border-warning justify-content-center rounded-circle"
                    style={{
                      width: "16px",
                      height: "16px",
                      fontSize: "12px",
                    }}
                  >
                    <div className="text-warning">?</div>
                  </div>
                  <div
                    className="position-absolute "
                    style={{
                      width: "70px",
                      height: "70px",
                      backgroundImage: `url(${userRank})`,
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      left: 0,
                      transform: "translateX(-50%)",
                    }}
                  ></div>
                </div>
              )}

              {userInfo.vip === "Vip 7" && (
                <div
                  className="ml-2 d-flex align-items-center border border-warning text-warning justify-content-center font-weight-bold"
                  style={{
                    width: "57px",
                    height: "36px",
                    borderRadius: "10px",
                    opacity: "0.6",
                    backgroundColor: "#82f92a1f",
                    fontSize: "10px",
                  }}
                >
                  Max Lv
                </div>
              )}
              {userInfo.vip !== "Vip 7" && (
                <div
                  className="ml-2 d-flex align-items-center border border-warning text-warning justify-content-center font-weight-bold"
                  style={{
                    width: "max-content",
                    height: "36px",
                    padding: "0px 10px",
                    borderRadius: "10px",
                    backgroundColor: "#82f92a1f",
                    fontSize: "10px",
                  }}
                >
                  <i
                    className="fas fa-up-long"
                    style={{
                      color: "yellow",
                    }}
                  ></i>
                  <span
                    className="ml-1"
                    onClick={() => {
                      this.props.handleChangeTab("upgrade");
                    }}
                    style={{
                      userSelect: "none",
                      cursor: "pointer",
                    }}
                  >
                    Upgrade lv
                  </span>
                </div>
              )}
            </div>
            <div className="row mb-2">
              <div className="col-12 col-lg">
                <p
                  className="mb-2"
                  style={{
                    color: "#ffffff80",
                  }}
                >
                  {t("TotalNumberOfTraders")}
                </p>
                <p style={{ fontSize: "20px", color: "#04c793" }}>
                  {userInfo.total_member_trade || 0}
                </p>
              </div>
              <div className="col-12 col-lg">
                <p
                  className="mb-2"
                  style={{
                    color: "#ffffff80",
                  }}
                >
                  {t("TotalOfVipMembers")}
                </p>
                <p style={{ fontSize: "20px", color: "#af40fe" }}>
                  {userInfo?.total_member_vip || 0}
                </p>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12 col-lg">
                <p
                  className="mb-2"
                  style={{
                    color: "#ffffff80",
                  }}
                >
                  {t("TotalCommissions")}
                </p>
                <p style={{ fontSize: "20px", color: "#fa4b62" }}>
                  {userInfo?.commisssion || 0}
                </p>
              </div>
              <div className="col-12 col-lg">
                <p
                  className="mb-2"
                  style={{
                    color: "#ffffff80",
                  }}
                >
                  {t("UpBranch")}
                </p>
                <p style={{ fontSize: "20px" }}>
                  {userInfo?.parent || "user parent"}
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-12 col-lg"
            style={{
              minHeight: "270px",
              padding: "20px",
              border: "1px solid #303539",
              borderRadius: "20px",
            }}
          >
            <h2
              style={{
                margin: "0 15px",
                fontSize: "20px",
              }}
            >
              <i
                class="fas fa-headset"
                style={{
                  marginRight: "14px",
                }}
              ></i>
              {t("Infomation")}
            </h2>
            <div
              className="row"
              style={{
                marginTop: "24px",
                padding: "0 15px",
              }}
            >
              <div className="col-12 col-md d-flex flex-column align-items-center">
                <img
                  src={userAvatar}
                  alt=""
                  style={{
                    width: "100px",
                    height: "100px",
                  }}
                />
                <p
                  style={{
                    marginTop: "16px",
                    fontSize: "20px",
                  }}
                >
                  {userInfo?.name || "user name"}
                </p>
              </div>
              <div className="col-12 col-md-7 d-flex flex-column justify-content-center">
                <div className="mb-4">
                  <p
                    style={{
                      marginBottom: "16px",
                      color: "#ffffff80",
                    }}
                  >
                    {t("EmailAddress")}
                  </p>
                  <p>
                    <i
                      className="fas fa-envelope"
                      style={{
                        marginRight: "16px",
                      }}
                    ></i>
                    <span>{userInfo?.email || "N/A"}</span>
                  </p>
                </div>
                <div>
                  <p
                    style={{
                      marginBottom: "16px",
                      color: "#ffffff80",
                    }}
                  >
                    {t("PhoneNumber")}
                  </p>
                  <p>
                    <i
                      className="fas fa-phone"
                      style={{
                        marginRight: "16px",
                      }}
                    ></i>
                    <span>{userInfo?.phone || "N/A"}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: "30px",
            minHeight: "471px",
            border: "1px solid #303539",
            borderRadius: "20px",
          }}
        >
          <ul
            data-v-5884b68b=""
            id="pills-tab"
            role="tablist"
            className="nav nav-pills menuHeaderLink"
            style={{
              gap: "20px",
              marginTop: "0",
              paddingTop: "0",
              borderBottom: "1px solid #303539",
              padding: "0px 20px",
            }}
          >
            <li
              data-v-5884b68b=""
              id="community"
              className="nav-item d-flex align-items-center"
            >
              <div
                onClick={() => {
                  this.handleSelectMonthTab("all");
                }}
                className={setClassNameCondition(
                  this.state.monthTab === "all",
                  "router-link-exact-active router-link-active",
                  "",
                  "nav-link"
                )}
                style={{
                  padding: "0",
                  lineHeight: "50px",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                {t("All")}
              </div>
            </li>
            <li
              data-v-5884b68b=""
              id="community"
              className="nav-item d-flex align-items-center"
            >
              <div
                onClick={() => {
                  this.handleSelectMonthTab("current");
                }}
                className={setClassNameCondition(
                  this.state.monthTab === "current",
                  "router-link-exact-active router-link-active",
                  "",
                  "nav-link"
                )}
                style={{
                  padding: "0",
                  lineHeight: "50px",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                {t("ThisMonth")}
              </div>
            </li>
            <li data-v-5884b68b="" id="portfolio" className="nav-item ">
              <div
                onClick={() => {
                  this.handleSelectMonthTab("prevMonth");
                }}
                className={setClassNameCondition(
                  this.state.monthTab === "prevMonth",
                  "router-link-exact-active router-link-active",
                  "",
                  "nav-link"
                )}
                style={{
                  padding: "0",
                  lineHeight: "50px",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                {t("LastMonth")}
              </div>
            </li>
          </ul>
          <div
            style={{
              padding: "20px",
              minHeight: "434px",
            }}
          >
            <div
              className="row"
              style={{
                minHeight: "414px",
              }}
            >
              <div className="col-12 col-lg mb-1">
                <h2
                  style={{
                    fontSize: "20px",
                  }}
                >
                  {t("RecentFigures")}
                </h2>
                <div
                  className="d-flex flex-column"
                  style={{
                    gap: "10px",
                    marginTop: "24px",
                  }}
                >
                  <label
                    htmlFor="klgd"
                    className="d-flex align-items-center"
                    style={{
                      gap: "10px",
                      color: "#30D6CE",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="options"
                      id="klgd"
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "#04c793",
                        color: "#04c793",
                      }}
                      value="totalTrade"
                      onChange={(e) => {
                        this.handleChangeRadio(e);
                      }}
                      checked={
                        this.state.ratioVal === "totalTrade" ? true : false
                      }
                    />
                    <span>{t("Total")} {t("TradingVolume")}</span>
                  </label>
                  <label
                    htmlFor="tshh"
                    className="d-flex align-items-center"
                    style={{ gap: "10px", color: "#fa4b62", cursor: "pointer" }}
                  >
                    <input
                      type="radio"
                      name="options"
                      id="tshh"
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "#04c793",
                        color: "#04c793",
                      }}
                      value="commission"
                      onChange={(e) => {
                        this.handleChangeRadio(e);
                      }}
                      checked={
                        this.state.ratioVal === "commission" ? true : false
                      }
                    />
                    <span>{t("TotalCommissionTrades")}</span>
                  </label>
                </div>
              </div>
              <div
                className="col-12 col-lg-8 mr-lg-3"
                style={{
                  padding: "20px",
                  border: "1px solid #303539",
                  borderRadius: "10px",
                }}
              >
                <HighchartsReact
                  ref={this.chartRef}
                  highcharts={Highcharts}
                  options={this.state.chartOptions}
                  containerProps={{
                    style: {
                      width: "100%",
                      height: "100%",
                      backgroundColor: "transparent",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DetailInfomation);
